import * as React from "react";
const SvgIcUserFilled = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 7.875c2.336 0 7 1.164 7 3.5V17H3v-2.625c0-2.336 4.664-3.5 7-3.5Z" /></svg>;
export default SvgIcUserFilled;